// @flow @jsx h

import { h } from 'preact'
import { Question } from './Question'
import { Options } from './Options'
import { Box } from './common/Box'

import type { Question as QuestionType } from '../../types'

type Props = {
  currentQuestion: QuestionType,
  onAnswerClick: () => void
}

const QuestionView = ({ currentQuestion, onAnswerClick }: Props) => {
  return (
    <Box>
      <Question question={currentQuestion} />
      <Options options={currentQuestion.options} onAnswerClick={onAnswerClick} />
    </Box>
  )
}

export { QuestionView }



// WEBPACK FOOTER //
// ./src/v1/components/Foreground/QuestionView.js